import React from "react"
import { Link } from "gatsby"
import { Button, Center, Heading, AspectRatio, Image } from "@chakra-ui/react"

import Dog from "~images/pages/404/dog.gif"
import ResponsiveBlock from "~components/shared/layout/responsive-block"

const NotFoundPage = () => {
    return (
        <ResponsiveBlock>
            <Center py={36} minH="600px" flexDir="column" gridGap={4}>
                <AspectRatio ratio={1} width="300px" h="300px">
                    <Image src={Dog} alt="A dog looking nervous" />
                </AspectRatio>
                <Heading textAlign="center">Uh oh! 404!</Heading>
                <Heading fontSize="xl" textAlign="center">
                    Seems like we can't find what you're looking for 😔
                </Heading>
                <Link to="/">
                    <Button>Back to Home</Button>
                </Link>
            </Center>
        </ResponsiveBlock>
    )
}

export default NotFoundPage
